import { Button } from 'aa_common/front-end/antd'
import { someTrue } from 'aa_common/front-end/helpers'
import React from 'react'
import { useFormContext } from 'react-hook-form'

const SubmitButton: React.FC = ({ children }) => {
  const { formState } = useFormContext()
  return (
    <Button disabled={someTrue(!formState.isValid, formState.isSubmitting)} type="submit">
      {children}
    </Button>
  )
}

export default SubmitButton
